import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { PublicLayout } from "../components/public/PublicLayout";
import { Store, Globe, UtensilsCrossed, Tag, PackageCheck, ShoppingCart, History, Info, Truck, Headphones, ArrowRight } from "lucide-react";

export default function Trade() {
  const { t } = useLang();
  const navigate = useNavigate();
  useEffect(() => { document.title = "Sambiva Trade | Brazilian Food Wholesale Europe"; }, []);

  const segments = [
    { icon: Store, title: t("trade.retailers"), d: "Stock authentic Brazilian favourites your customers keep coming back for." },
    { icon: Globe, title: t("trade.online"), d: "Reliable supply and product data to power your online store." },
    { icon: UtensilsCrossed, title: t("trade.restaurants"), d: "Consistent ingredients for kitchens that value authenticity." },
  ];
  const benefits = [
    { icon: Tag, label: "Wholesale pricing" },
    { icon: PackageCheck, label: "Stock visibility" },
    { icon: ShoppingCart, label: "Easy ordering" },
    { icon: History, label: "Order history" },
    { icon: Info, label: "Product information" },
    { icon: Truck, label: "Reliable distribution" },
    { icon: Headphones, label: "Account support" },
  ];

  return (
    <PublicLayout>
      <section className="relative bg-sambiva-charcoal text-white overflow-hidden">
        <img src="https://images.unsplash.com/photo-1719427131242-5a5dbe78740f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 py-28 text-center">
          <span className="inline-block text-xs font-bold tracking-widest text-sambiva-yellow uppercase mb-4">Sambiva Trade</span>
          <h1 className="font-serif text-4xl sm:text-6xl mb-5">{t("trade.title")}</h1>
          <p className="text-white/85 text-lg max-w-2xl mx-auto mb-9">{t("trade.sub")}</p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <button data-testid="trade-become-partner" onClick={() => navigate("/partner")} className="bg-sambiva-red hover:bg-sambiva-deepred text-white font-semibold px-7 py-3.5 rounded-full transition-all hover:-translate-y-0.5">{t("trade.cta")}</button>
            <button data-testid="trade-login-btn" onClick={() => navigate("/trade/login")} className="border-2 border-white/70 text-white font-semibold px-7 py-3.5 rounded-full hover:bg-white/10 transition-colors">{t("trade.loginLink")}</button>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
        <div className="grid md:grid-cols-3 gap-6">
          {segments.map((s, i) => (
            <div key={i} className="bg-white rounded-3xl p-8 border border-sambiva-charcoal/5 card-hover">
              <div className="w-14 h-14 rounded-2xl bg-sambiva-green/10 flex items-center justify-center mb-5"><s.icon className="text-sambiva-green" size={26} /></div>
              <h3 className="font-serif text-2xl text-sambiva-charcoal mb-2">{s.title}</h3>
              <p className="text-sambiva-muted leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <h2 className="font-serif text-3xl sm:text-4xl text-sambiva-charcoal text-center mb-14">{t("trade.benefitsTitle")}</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
            {benefits.map((b, i) => (
              <div key={i} className="flex items-center gap-3 bg-sambiva-cream rounded-2xl px-5 py-4">
                <b.icon className="text-sambiva-red shrink-0" size={22} />
                <span className="font-medium text-sambiva-charcoal text-sm">{b.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-sambiva-green text-sambiva-cream">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-20 text-center">
          <h2 className="font-serif text-3xl sm:text-4xl mb-4">Bring more Brazil to your customers.</h2>
          <p className="text-sambiva-cream/85 text-lg mb-8">{t("trade.existing")} <button onClick={() => navigate("/trade/login")} className="underline font-semibold text-sambiva-yellow">{t("trade.loginLink")}</button></p>
          <button data-testid="trade-cta-partner" onClick={() => navigate("/partner")} className="inline-flex items-center gap-2 bg-sambiva-yellow text-sambiva-charcoal font-semibold px-7 py-3.5 rounded-full hover:bg-white transition-colors">{t("trade.cta")} <ArrowRight size={16} /></button>
        </div>
      </section>
    </PublicLayout>
  );
}
